function truncateText(el) {
  const charLimit = 150;
  const shortText = document.createElement('span');
  const originalContent = el.innerHTML;
  const text = el.textContent.trim();

  if (text.length > charLimit) {
    if (!el.nextElementSibling || !el.nextElementSibling.classList.contains('read-more')) {
      const readMoreSpan = document.createElement('span');
      readMoreSpan.className = 'read-more';
      readMoreSpan.innerHTML = '&nbsp;<span class="more">show more</span>';
      el.parentNode.insertBefore(readMoreSpan, el.nextSibling);
    }
    el.setAttribute('data-originalContent', originalContent);
    shortText.textContent = `${text.substring(0, charLimit)}...`;
    // eslint-disable-next-line no-param-reassign
    el.innerHTML = '';
    el.appendChild(shortText);
  }
}

function reveal(el) {
  // eslint-disable-next-line no-param-reassign
  el.innerHTML = el.getAttribute('data-originalContent');
}

const handleClick = e => {
  if (e.target && e.target.classList.contains('more')) {
    const truncateElement = e.target.parentElement.previousElementSibling;
    if (e.target.textContent === 'show more') {
      e.target.textContent = 'show less';
      e.target.classList.add('show-less');
      reveal(truncateElement);
    } else {
      if (e.target.classList.contains('show-less')) e.target.classList.remove('show-less');
      e.target.textContent = 'show more';
      truncateText(truncateElement);
    }
  }
};

function truncate(targetBlock, truncateClass = '.truncate') {
  document.querySelector(targetBlock).addEventListener('click', handleClick);

  document.querySelectorAll(`${targetBlock} ${truncateClass}`).forEach(element => {
    truncateText(element);
  });
}

function truncateDestroy(targetBlock) {
  document.querySelector(targetBlock).removeEventListener('click', handleClick);
}

export { truncateDestroy };
export default truncate;
